export const accordionSummaryStyles = {
  '&.MuiAccordionSummary-root': {
    minHeight: 'unset',
    padding: '12px',
    flexDirection: 'row-reverse',
    gap: '8px',

    '&.Mui-expanded': {
      minHeight: 'unset',
      borderBottom: '1px solid',
      borderBottomColor: 'divider',
    },
  },

  '& .MuiAccordionSummary-content': {
    margin: 0,
    alignItems: 'center',
    gap: '8px',
    '&.Mui-expanded': {
      margin: 0,
    },
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    display: 'flex',
    color: 'text.secondary',
    transform: 'rotate(-90deg)',
    transition: 'transform 150ms',
    '&.Mui-expanded': {
      transform: 'rotate(0deg)',
    },
  },
};

export const titleStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  minWidth: 0,
  flex: 1,
};

export const statusLineStyles = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',
};

export const summaryContentWrapperStyles = {
  width: '100%',
  gap: '4px',
};

export const typeIconWrapperStyles = {
  display: 'flex',
  alignItems: 'center',
  color: 'primary.main',
};
